import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Page from 'components/widgets/Route';
import * as actions from './actions';
import Updates from './container/Updates';

class UpdatesRoute extends React.Component {
	constructor(props) {
		super(props);
		this.fetchUpdates = this.fetchUpdates.bind(this);
	}

	fetchUpdates() {
		this.props.actions.fetchUpdates();
	}

	render() {
		const { match: { path } } = this.props;
		return (
			<Page>
				<Page.Route
					exact
					path={path}
					onEnter={this.fetchUpdates}
					component={Updates}
				/>
			</Page>
		);
	}
}

UpdatesRoute.propTypes = {
	match: PropTypes.shape({
		path: PropTypes.string.isRequired
	}).isRequired
};

function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(actions, dispatch)
	};
}

export default connect(
	null,
	mapDispatchToProps
)(UpdatesRoute);
